import React from 'react';
import { Form } from 'antd';
import CustomerTextInput from '../../inputs/customerTextInput/CustomerTextInput';
import useTranslation from '../../../hooks/translation/useTranslation';
import DefaultButton from '../../components/buttons/defaultButton/DefaultButton';

function SendPasswordRecoveryForm({ form, handleSubmit, loading }) {
  const { trans } = useTranslation();
  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
    >
      <CustomerTextInput
        label={trans('email')}
        name="email"
        rules={[
          {
            required: true,
            message: trans('input_necessary'),
          },
        ]}
      />
      <div className="flex justify-center">
        <DefaultButton
          disabled={loading}
          type="submit"
          className="text-base leading-[22px] w-full lg:w-auto"
        >
          {trans('send')}
        </DefaultButton>
      </div>
    </Form>
  );
}

export default SendPasswordRecoveryForm;
